<div class="flex-it flex-col">
  @if (loadingSentences) {
    <app-loading-overlay> </app-loading-overlay>
  }

  @if (!displayingDeltaPlusMinusSentences) {
    <section class="flex-it flex-row flex-xcontent-center">
      <div class="label">Sentences</div>
      <div class="flex-it flex-content-end flex-2">
        <div
          class="metrics-container flex-it flex-row flex-xcontent-start flex-content-end"
        >
          <!-- Delta Metrics -->
          @if (deltaModeIsActive && !displayingChipotletSentences) {
            <div class="delta-metrics-container flex-it flex-row">
              <div>
                Δ Sentences
                <div class="flex-it flex-col">
                  <div>
                    <span
                      class="clickable"
                      (click)="searchDeltaSentences(true)"
                      matTooltip="Delta Sentence Plus"
                    >
                      +
                      {{ deltaSentencePlusHitCount | number: "1.0" : "en-US" }}
                      /
                    </span>
                    <span
                      class="clickable"
                      (click)="searchDeltaSentences(false)"
                      matTooltip="Delta Sentence Minus"
                    >
                      -
                      {{ deltaSentenceMinusHitCount | number: "1.0" : "en-US" }}
                    </span>
                  </div>
                  <span matTooltip="Delta Sentence %">
                    (Δ {{ deltaSentenceVolumePercentage | percent: "1.2-2" }})
                  </span>
                </div>
              </div>
              <div class="delta-verbatims-container">
                Δ Verbatims
                <div class="flex-it flex-col">
                  <div>
                    <span matTooltip="Delta Verbatim Plus">
                      +
                      {{ deltaVerbatimPlusHitCount | number: "1.0" : "en-US" }}
                      /
                    </span>
                    <span matTooltip="Delta Verbatim Minus">
                      -
                      {{ deltaVerbatimMinusHitCount | number: "1.0" : "en-US" }}
                    </span>
                  </div>
                  <span matTooltip="Delta Sentence %">
                    (Δ {{ deltaSentenceVolumePercentage | percent: "1.2-2" }})
                  </span>
                </div>
              </div>
            </div>
          }
          <!-- Sentence Metrics -->
          <div class="sentence-metrics-container flex-it flex-row">
            <span class="sentence-results-hit-count">
              {{ sentenceHitCount | number: "1.0" : "en-US" }}
            </span>
            <div
              class="sentence-results-percentage-container flex-it flex-xcontent-end"
            >
              sentences in
              <span class="sentence-results-percentage">
                ({{ sentenceVolumePercentage | percent: "1.2-2" }})
              </span>
            </div>
            <span class="sentence-results-hit-count">
              {{ verbatimHitCount | number: "1.0" : "en-US" }}
            </span>
            <div
              class="sentence-results-percentage-container flex-it flex-xcontent-end"
            >
              verbatims
              <span class="sentence-results-percentage">
                ({{ verbatimVolumePercentage | percent: "1.2-2" }})
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  }

  <!-- Sentence Results -->
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="sentence">
      <th mat-header-cell *matHeaderCellDef>Sentence</th>
      <td mat-cell *matCellDef="let row">
        {{
          row.sentence.length >= 90
            ? (row.sentence | slice: 0 : 90) + "..."
            : row.sentence
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="sentiment-value">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="flex-it flex-row flex-xcontent-center"
      >
        Sentiment Value
        <div
          class="flex-it sorting-arrows clickable"
          matTooltip="Sort by Sentiment"
          (click)="handleSortBySentiment()"
        >
          <ng-icon
            name="HeroArrowNarrowUp"
            [class.highlighted]="sortSentimentBy === 'asc'"
            [attr.aria-label]="'Sort sentiment ascending'"
          ></ng-icon>
          <ng-icon
            name="HeroArrowNarrowDown"
            [class.highlighted]="sortSentimentBy === 'desc'"
            [attr.aria-label]="'Sort sentiment descending'"
          ></ng-icon>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">
        {{
          row.sentiments[sentimentVersionId] ||
          row.sentiments[sentimentVersionId] === 0
            ? (row.sentiments[sentimentVersionId] | number: "1.2-2")
            : "N/A"
        }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [ngClass]="{ 'clickable-row': rowsClickable }"
      (click)="onRowClicked(row)"
    ></tr>
  </table>

  @if (!(sentences?.hits?.length > 0)) {
    <div class="no-results">No results</div>
  }
  @if (sentences?.total?.value > 7) {
    <mat-paginator
      [length]="sentences?.total?.value"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      (page)="onPage($event)"
      [showFirstLastButtons]="true"
      [hidePageSize]="true"
    ></mat-paginator>
  }
</div>
